import { render, staticRenderFns } from "./editInsurance.vue?vue&type=template&id=767231ef&scoped=true"
import script from "./editInsurance.vue?vue&type=script&lang=js"
export * from "./editInsurance.vue?vue&type=script&lang=js"
import style0 from "./editInsurance.vue?vue&type=style&index=0&id=767231ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767231ef",
  null
  
)

export default component.exports